export default function getAppropriateFiltersFormat(columns) {
  const filters = {};

  columns.forEach((col) => {
    // Only add filter if it has a non-empty value
    if (col.filter.value) {
      console.log(`Processing filter for ${col.key}:`, {
        value: col.filter.value,
        type: typeof col.filter.value
      });
      
      if (col.key === "voted")
        filters[col.key] = col.filter.value === "Voted" ? "1" : "0";
      else if (col.key === "sbisd_voted") {
        filters[col.key] = col.filter.value === "Voted" ? "1" : col.filter.value === "Not Voted" ? "0" : null;
      } else if (col.key === 'signup_timestamp_central' || col.key === 'last_activity_at') {
        let obj = getDateRange(col.filter.value)
        filters[col.key] = obj
      }
      else 
        filters[col.key] = col.filter.value.toString().toLowerCase().trim();
    }
  });

  console.log("Final filters object:", filters);
  return filters;
}

const getDateRange = (filterValue) => {
  const today = new Date();
  let startDate, endDate;

  const formatDate = (date) => {
    return `${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getDate().toString().padStart(2, '0')}/${date.getFullYear()}`;
  };

  switch (filterValue) {
    case 'Today':
      startDate = endDate = today;
      break;

    case 'Yesterday':
      const yesterday = new Date(today);
      yesterday.setDate(yesterday.getDate() - 1);
      startDate = endDate = yesterday;
      break;

    case 'Last 7 Days':
      startDate = new Date(today);
      startDate.setDate(today.getDate() - 6);
      endDate = today;
      break;

    case 'This Week':
      const firstDayOfWeek = new Date(today);
      firstDayOfWeek.setDate(today.getDate() - today.getDay()); // Sunday
      startDate = firstDayOfWeek;
      endDate = today;
      break;

    case 'Last Week':
      const lastWeekStart = new Date(today);
      lastWeekStart.setDate(today.getDate() - today.getDay() - 7); // Previous Sunday
      const lastWeekEnd = new Date(lastWeekStart);
      lastWeekEnd.setDate(lastWeekStart.getDate() + 6); // Next Saturday
      startDate = lastWeekStart;
      endDate = lastWeekEnd;
      break;

    case 'This Month':
      startDate = new Date(today.getFullYear(), today.getMonth(), 1);
      endDate = today;
      break;

    case 'Last Month':
      const lastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
      const lastMonthEnd = new Date(today.getFullYear(), today.getMonth(), 0);
      startDate = lastMonth;
      endDate = lastMonthEnd;
      break;

    case 'This Year':
      startDate = new Date(today.getFullYear(), 0, 1);
      endDate = today;
      break;
    
    case 'Last 90 Days':
      startDate = new Date(today);
      startDate.setDate(startDate.getDate() - 89); // Including today
      endDate = new Date(today);
      break;


    default:
      startDate = endDate = today;
  }

  return {
    start_date: formatDate(startDate),
    end_date: formatDate(endDate)
  };
};
